import React, { useState } from "react";
import type { RFQ } from "../../../../types/rfq";

/** The RFQs ticked for a mass delete, and the header's select-all box. */
export function useRfqSelection(visibleRfqs: RFQ[]) {
  const [selectedRfqs, setSelectedRfqs] = useState<number[]>([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const toggleRfq = (rfqId: number) => {
    setSelectedRfqs(prev => (prev.includes(rfqId) ? prev.filter(id => id !== rfqId) : [...prev, rfqId]));
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);
    setSelectedRfqs(checked ? visibleRfqs.map(rfq => rfq.rfq_id) : []);
  };

  const clearSelection = () => {
    setSelectedRfqs([]);
    setSelectAllChecked(false);
  };

  return { selectedRfqs, selectAllChecked, toggleRfq, handleSelectAll, clearSelection };
}

export type RfqSelection = ReturnType<typeof useRfqSelection>;
